<template>
<div class="foruwizard-step">
  <h1 class="foruwizard-step-header">Выберите категорию</h1>
  <div class="foruwizard-step-content">
    <div class="foruwizard-step-header-small">Категория сайта <span class="text-negative">*</span></div>
    <div class="form-group foruwizard-form">
      <div style="max-width: 416px">
        <q-form autocomplete="off" ref="companyDataForm">
         <div>
           <q-select color="primary" :rules="[ val => val && testCategory(val) || 'Выберите категорию']" outlined v-model="currentcategory" :options="categoryselectoptions" label="Выбор категории"  @input="selectCategory"></q-select>
         </div>
         <div class="foruwizard-step-header-small q-mt-lg">Описание компании</div>
         <q-input :rules="[
         val => val && val.length > 1 || 'Укажите краткое описание',
         val => val && val.length < 2048 || 'Описание слишком длинное'
          ]" lazy-rules color="primary" type="textarea" outlined v-model="company.description" v-on:input="updateVars" label="Описание" />
         <br/>
         <div class="foruwizard-step-header-small q-mt-lg">Facebook</div>
         <q-input color="primary" outlined v-model="company.facebook" v-on:input="updateVars" label="Ссылка на Facebook" />
         <div class="foruwizard-step-header-small q-mt-lg">Instagram</div>
         <q-input color="primary" outlined v-model="company.instagram" v-on:input="updateVars" label="Ссылка на Instagram" />
         <div class="foruwizard-step-header-small q-mt-lg">ВКонтакте</div>
         <q-input color="primary" outlined v-model="company.vkontakte" v-on:input="updateVars" label="Ссылка на ВКонтакте" />
        </q-form>
     </div>
    </div>
    <div class="form-group foruwizard-form-group-bottom">
      <a href="javascript:void(0)" @click="nextStep()" class="foruwizard-btn-salmon">Далее</a>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios';

export default {
  data: function(){
    return {
      company: {
        name: this.propObj.data.name,
        address: this.propObj.data.address,
        phone: this.propObj.data.phone,
        email: this.propObj.data.email,
        category: this.propObj.data.category,
        description: this.propObj.data.description,
        facebook: this.propObj.data.facebook,
        instagram: this.propObj.data.instagram,
        vkontakte: this.propObj.data.vkontakte
      },
      currentcategory: null,
      categoryselectoptions: [
        {label: 'Автомойки, автосервисы, СТО',value: "1"},
        {label: 'Детские центры и сады, образование',value: "2"},
        {label: 'Квесты, атракционы, сауны, развлечения',value:"3"},
        {label: 'Недвижимость',value:"4"},
        {label: 'Медицинские центры и стоматологии, Аптеки',value: "5"},
        {label: 'Печатный бизнес, СМИ',value: "6"},
        {label: 'Производство, заводы, фабрики',value: "7"},
        {label: 'Рестораны, кафе, бары, пиццерии',value: "8"},
        {label: 'Салоны красоты, маникюра, здоровье',value: "9"},
        {label: 'Строительный бизнес',value: "10"},
        {label: 'Хостелы, отели, мини-гостиницы',value: "11"},
        {label: 'Финансы',value: "12"}

      ]
    }
  },
  props: {
    propObj: {type: Object},
    myNextStep: {type: Function}
  },
  methods: {
    testCategory(val){
      console.log("CHECK VAL");
      console.log(val);
      if(val.value){
        return true;
      }
//      let res = false;
//      if(val){
//        if(val.value){
//          res = true
//        }
//      }

    },
    selectCategory (val) {
      console.warn("selectCategory");
      console.warn(val);
      console.log(val.value);
      let self = this;
      let url = "http://localhost:3000/api/v1/wizard/"+val.value;
      if(window.location.host.indexOf("localhost") > -1){
        url = "http://localhost:3000/api/v1/wizard/"+val.value;
      }else{
        url = "https://editor.fo.ru/api/v1/wizard/"+val.value;
      }
      console.log(url);
      axios
        .get(url, "")
        .then(function (response) {
          console.warn(response);
          if(response.data.length > 0){
            let category_id = response.data[0]["_id"]["$oid"];
            self.company.category = val.value;
            self.company.template_id = category_id;
            self.$emit('updatecompany', self.company);
          }
        });
    },
    nextStep: function(){
      console.log("NEXTSTEP");
      console.log(this.$refs.companyDataForm);
      this.$refs.companyDataForm.validate().then(success => {
        if(success){
          this.myNextStep(4);
        }
      });

//        if (success) {
//          this.myNextStep(4);
//        }else{
//          alert("FORM ERROR");
//        }
//      });
//      this.myNextStep(4);
    },
    updateVars: function(){
      this.$emit('updatecompany', this.company)
    }
  }

}
</script>

<style lang="scss">
.q-field__control-container.col.relative-position.row.no-wrap.q-anchor--skip{
  margin-left: 0;
}
</style>
